import type { BeforeSendFn, CaptureResult } from "posthog-js";

export const dropOpaqueScriptErrors: BeforeSendFn = (event) => {
  if (!event || event.event !== "$exception") return event;
  return isOpaqueScriptError(event) ? null : event;
};

export function isOpaqueScriptError(event: CaptureResult): boolean {
  const properties = event.properties ?? {};
  if (isScriptErrorMessage(properties.$exception_message)) return true;

  const list = properties.$exception_list;
  if (!Array.isArray(list) || list.length === 0) return false;

  const first = list[0];
  if (!first || typeof first !== "object") return false;

  const exception = first as { type?: unknown; value?: unknown };
  return isScriptErrorMessage(exception.value) || isScriptErrorMessage(exception.type);
}

function isScriptErrorMessage(value: unknown): boolean {
  return typeof value === "string" && value.replace(/\.$/, "") === "Script error";
}
